<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33"
      >
        <h3>Businesses</h3> <p>Select a business to continue.</p>
        <div class="table-body">
          <md-table table-header-color="green">
            <md-table-row>
              <md-table-head>Name</md-table-head>
              <md-table-head>Type</md-table-head>
              <md-table-head></md-table-head>
            </md-table-row>
            <md-table-row
              v-for="(business, index) in this.businesses"
              :key="index"
            >
              <md-table-cell md-label="Name">
                {{ business.name }}
              </md-table-cell>
              <md-table-cell md-label="Operation">
                {{ business.type }}
              </md-table-cell>
              <md-table-cell md-label="Type">
                <a href="#" @click="select(business)">Select</a>
              </md-table-cell>
            </md-table-row>
          </md-table>

          <md-table v-if="isBusinessesLoading">
            <p style="padding: 10px">Loading data</p>
          </md-table>
        </div>
      </div>
    </div>

    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import http from '../utils/Http.util';

export default {
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    loading() {
      return this.$store.state.loading;
    },
  },
  data() {
    return {
      businesses: [],
      isBusinessesLoading: false,
      snackBar: {
        show: false,
        message: null,
      },
    };
  },
  methods: {
    async select(business) {
      await this.updateActiveBusiness(business);
    },
    async updateActiveBusiness(business) {
      this.$store.commit('busyStatus', true);

      try {
        const result = await http.authReq(
          '/dashboard/me/business-accesses/active',
          { business_id: business.id },
          'put',
        );

        const { message } = result;

        this.$store.commit('setActiveBusiness', business);

        this.$router.push({ path: '/' });

        this.snackBar = {
          show: true,
          message,
        };

        this.$store.commit('busyStatus', false);
      } catch (err) {
        this.snackBar = {
          show: true,
          message: err.response ? err.response.data.message : err.message,
        };
        this.$store.commit('busyStatus', false);
      }
    },

    getBusinesses() {
      this.isBusinessesLoading = true;
      http
        .authReq('/dashboard/me/business-accesses')
        .then((result) => {
          const { data } = result;

          this.businesses = data.map((item) => item.business);
          this.$store.commit('busyStatus', false);
          this.isBusinessesLoading = false;
        })
        .catch((err) => {
          this.$store.commit('busyStatus', false);
          this.isBusinessesLoading = false;
          this.snackBar = {
            show: true,
            message: err.response ? err.response.data.message : err.message,
          };
        });
    },
  },
  mounted() {
    this.businesses = this.$store.state.businesses;
    this.getBusinesses();
  },
  created() {},
};
</script>

<style lang="scss" scoped></style>
